module.exports = __webpack_public_path__ + "img/srlogo.80f7b149.svg";